












import { defineComponent } from '@vue/composition-api';
import AppText from '@berlin-front/common/components/elements/AppText';

/**
 * ## AppFormGroupコンポーネント。
 */
export default defineComponent({
  name: 'AppFormGroup',
  components: {
    AppText,
  },

  props: {
    /**
     * 必須項目表示（※）
     */
    required: {
      type: Boolean,
      default: false,
    },

    /**
     * タイトル
     */
    title: {
      type: String,
      required: true,
      default: '',
    },
  },

  setup() {
    return {};
  },
});
